import React, { useState, useRef, useContext } from "react";
import { ReactSession } from "react-client-session";
import kingdomImg from '../../assets/logo_kingdom_256px.png';
import ReCAPTCHA from "react-google-recaptcha";
import { ContextGloball } from "../Context/ContextGlobal";
import Modal from 'react-bootstrap/Modal';
import msg from '../Tools/MsgUtils';
import ConsultasUsuarios from '../Sql/ConsultasUsuarios'
import '../css/Login.css';

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";



const idModulo = 145;
const server = process.env.REACT_APP_SERVER;

function Tareas({ setLoginAcceso }) {
    const { setSingUp, setShowMenu } = useContext(ContextGloball);
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [showPasword, setShowPasword] = useState(false);
    const [regional, setRegional] = useState('');
    const [carnet, setCarnet] = useState('');
    const [celular, setCelular] = useState('');
    const [vista, setVista] = useState(0);
    const [error, setError] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [info, setInfo] = useState({});
    const [validoCaptcha, setValidoCaptcha] = useState(null);
    const captchat = useRef(null);
    const [regionales,setRegionales] = useState([]);


    const navigate = useNavigate(); // <--- agregamos navigate

   const loginInvitado = () => {
        const invitado = {
            ID_EMPLEADO: -1,
            NOMBREX: "INVITADO",
            CARGO: "INVITADO",
            PERMISO: "N",
            FOTO: null,
            EMPRESA_SUCURSAL: null,
            TIPO_USUARIO: "INVITADO"
        };

            localStorage.setItem("info", JSON.stringify(invitado));

            ReactSession.set("idSession", invitado.ID_EMPLEADO);
            ReactSession.set("nombre", invitado.NOMBREX);
            ReactSession.set("cargo", invitado.CARGO);
            ReactSession.set("tipo", invitado.PERMISO);
            ReactSession.set("permiso", false);
            ReactSession.set("regional", null);

            localStorage.setItem('timeInit', new Date().getTime());

            setLoginAcceso(true);

             // redirección después de login
            const redirect = localStorage.getItem("redirectAfterLogin");
            if (redirect) {
                localStorage.removeItem("redirectAfterLogin");
                navigate(redirect, { replace: true });
            }

    };

    const handleSubmint = async (e) => {
        e.preventDefault();
        setShowMenu(false);
        if (usuario !== '') {
            if (password !== '') {
                if (regional !== '') {
                    try {
                        var respuesta = await ConsultasUsuarios.loginUsuario({
                            usuario,
                            password,
                            idModulo,
                            regional
                        })
                        if (respuesta.ok) {
                            setSingUp(respuesta.ok);
                            var data = respuesta.ok;
                            if (data.ID_EMPLEADO == 1) {
                                data.PERMISO = "0";
                            }
                            localStorage.setItem("info", JSON.stringify(data));
                            ReactSession.set("idSession", data.ID_EMPLEADO);
                            ReactSession.set("nombre", data.NOMBREX);
                            ReactSession.set("cargo", data.CARGO);
                            ReactSession.set("foto", data.FOTO);
                            ReactSession.set("tipo", data.PERMISO);
                            ReactSession.set("regional", regional);
                            ReactSession.set("empresaSucursal", data.EMPRESA_SUCURSAL);
                            if (data.PERMISO != null) {
                                ReactSession.set("permiso", true);
                            } else {
                                ReactSession.set('permiso', false);
                            }
                            setUsuario('');
                            setPassword('');
                            localStorage.setItem('timeInit', new Date().getTime());
                            setLoginAcceso(true);
                            // REDIRECCIÓN AUTOMÁTICA SI VENÍA DE OTRA PÁGINA
                            const redirect = localStorage.getItem("redirectAfterLogin");
                            if (redirect) {
                                localStorage.removeItem("redirectAfterLogin");
                                window.location.href = redirect;
                            }
                        } else {
                            msg.msgError(respuesta.error);
                        }
                    } catch (error) {
                        msg.msgError(error);
                    }
                    /*fetch(`${server}/sqlComun/empleados/login`, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            usuario,
                            password,
                            idModulo,
                            regional
                        })
                    })
                        .then(res => res.json())
                        .then(data => {
                            if (data.login === undefined) {
                                setSingUp(data);
                                if(data.ID_EMPLEADO==1){
                                    data.PERMISO = "0";
                                }
                                localStorage.setItem("info", JSON.stringify(data));
                                ReactSession.set("idSession", data.ID_EMPLEADO);
                                ReactSession.set("nombre", data.NOMBREX);
                                ReactSession.set("cargo", data.CARGO);
                                ReactSession.set("foto", data.FOTO);
                                ReactSession.set("tipo", data.PERMISO);
                                ReactSession.set("regional", regional);
                                ReactSession.set("empresaSucursal", data.EMPRESA_SUCURSAL);
                                if (data.PERMISO != null) {
                                    ReactSession.set("permiso", true);
                                } else {
                                    ReactSession.set('permiso', false);
                                }
                                setUsuario('');
                                setPassword('');
                                localStorage.setItem('timeInit',new Date().getTime());
                                setLoginAcceso(true);
                            } else {
                                msg.msgError("Nombre usuario o contraseña incorrectas");
                            }
                        })
                        .catch(err => msg.msgError(err));*/
                } else {
                    msg.msgError("Seleccione la regional !!!")
                }
            } else {
                msg.msgError("Ingrese contraseña !!!");
            }
        } else {
            msg.msgError("Coloque un usuario !!!");
        }
    }
    const onChange = () => {
        if (captchat.current.getValue()) {
            setValidoCaptcha(true);
        }
    }
    const irARecuperar = () => {
        setVista(1);
        setCarnet('');
        setCelular('');
        setRegional('');
        setError({});
    }
    function verificarCampos() {
        if (celular === '' && carnet === '' && regional === '') {
            setError({ "error": "Se requiere este Campo" });
            msg.msgError("No se permite campos vacios");
            return false;
        }
        return true;
    }
    const buscarUsuario = () => {
        if (verificarCampos()) {
            fetch(`${server}/sqlComun/empleados/recuperarUsuario`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    carnet, celular, regional
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setInfo(data.ok[0]);
                        setModalShow(true);
                    } else {
                        msg.msgError(data.error);
                        setError(data);
                    }
                })
                .catch(err => msg.msgError(err));
        }
    }

    useEffect(() => {
      
       fetch(`${server}/sqlComun/getConexiones`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (data && data.conexiones) {
                        setRegionales(data.conexiones);
                    } else {
                        msg.msgError(data?.error || 'No se pudieron obtener las conexiones');
                        setError(data);
                    }
                })
                .catch(err => {
                    console.error(err);
                    msg.msgError(err.message);
                });
        }
     , []);

    return (
        <div className="h-100 my-4" style={{ height: 'vh-75' }}>
            {vista === 0 &&
                <form onSubmit={handleSubmint}>
                    <div className="container-fluid " >
                        <div className="d-flex justify-content-center align-items-center " >
                            <div className="card px-4 py-2 bg-dark bg-gradient text-white" id="form1">
                                <div className="form-data" v-if="!submitted">
                                    <div className="forms-inputs mb-4 text-center">
                                        <div className="position-relative align-items-center">
                                            <img src={kingdomImg} width="95" className="align-items-center" />
                                        </div>
                                    </div>
                                    <div className="forms-inputs mb-4">
                                        <span>Usuario</span>
                                        <input type="text"
                                            className="form-control text-center ds-input"
                                            placeholder="Usuario"
                                            autoFocus
                                            onChange={(e) => setUsuario(e.target.value.toLowerCase())}
                                            value={usuario}
                                        />
                                    </div>
                                    <div className="forms-inputs mb-4">
                                        <span>Contraseña</span>
                                        <div className="input-group ">
                                            <input type={showPasword == true ? 'text' : "password"}
                                                className="form-control text-center"
                                                placeholder="Contraseña"
                                                autoFocus
                                                onChange={(e) => setPassword(e.target.value)}
                                                value={password}
                                            />
                                            {showPasword == false &&
                                                <button type='button'
                                                    className="btn btn-light"
                                                    onClick={() => setShowPasword(!showPasword)}>
                                                    <i className="fa-solid fa-eye"></i>
                                                </button>}
                                            {showPasword == true &&
                                                <button type='button'
                                                    className="btn btn-light"
                                                    onClick={() => setShowPasword(!showPasword)}>
                                                    <i className="fa-solid fa-eye-slash"></i>
                                                </button>}
                                        </div>
                                    </div>
                                    <div className="forms-inputs mb-2">
                                        <span>Regional</span>
                                        <select className="form-select btn-sm btn-light text-center " onChange={(e) => setRegional(e.target.value)}>
                                            <option value=''> NINGUNO</option>
                                            {/*<option value="990">Cochabamba</option>
                                            <option value="991">Santa Cruz</option>*/}
                                            {regionales.map((item) => (
                                               <option value={item.idRegional}>{item.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="forms-inputs mb-4 mx-auto text-center d-none">
                                        <ReCAPTCHA
                                            ref={captchat}
                                            className="g-recaptcha"
                                            theme="dark"
                                            sitekey="6LcktxUgAAAAAI7TXwwBes8u9bz79PnCsweM6IL0"
                                            onChange={onChange}
                                        />
                                        {validoCaptcha === false && <div className="badge bg-danger text-wrap">
                                            Valida el captchat antes de entrar
                                        </div>}
                                    </div>
                                    <div className="forms-inputs mb-4 mx-auto text-center">
                                        <a className="text-secondary btn" onClick={() => irARecuperar()}>Olvide mi Contraseña?</a>
                                    </div>
                                    <div className="forms-inputs mb-4 text-center">
                                        <button className='btn btn-secondary bg-gradient' type="Submit">
                                            <i className="fa-solid fa-user-tie"></i>
                                            <span className="px-1">Entrar</span></button>
                                    </div>
                                    <div className="forms-inputs mb-4 text-center">
                                        <button
                                                    type="button"
                                                    className="btn btn-secondary bg-gradient"
                                                    onClick={loginInvitado}  
                                                    ><span className="px-1">Ingresar como Invitado</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>}
            {vista === 1 &&
                <div className="container-fluid ">
                    <div className="d-flex justify-content-center py-2 ">
                        <div className="card px-2 py-2 bg-dark bg-gradient text-white col-12 col-sm-12 col-md-6 col-xl-4">
                            <div className="card-header m-0 p-0 bg-gradient">
                                <div className="container-fluid ">
                                    <div className="row row-cols-2 g-1">
                                        <div className="col-11 text-start">
                                            Recuperar Contraseña
                                        </div>
                                        <div className="col-1 text-end">
                                            <button className="btn btn-sm m-0 p-0 text-danger" onClick={() => setVista(0)}>
                                                <i className="fa-solid fa-circle-xmark fa-2xl"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="alert alert-warning text-uppercase">
                                    Solo si eres parte la empresa podras recuperar tu contraseña !!!!
                                </div>
                                <div className="forms-inputs mb-4">
                                    <span>Numero de Carnet</span>
                                    <input type="password"
                                        className="form-control text-center"
                                        placeholder="CI"
                                        autoFocus
                                        onChange={(e) => { setCarnet(e.target.value); setError({}) }}
                                        value={carnet}
                                    />
                                    {error.error !== undefined && carnet == '' && <div className="alert alert-danger text-uppercase m-0 p-0">
                                        {error.error}
                                    </div>}
                                </div>
                                <div className="forms-inputs mb-4">
                                    <span>Numero de Celular</span>
                                    <input type="password"
                                        className="form-control text-center"
                                        placeholder="# Celular"
                                        autoFocus
                                        onChange={(e) => { setCelular(e.target.value); setError({}) }}
                                        value={celular}
                                    />
                                    {error.error !== undefined && celular == '' && <div className="alert alert-danger text-uppercase m-0 p-0">
                                        {error.error}
                                    </div>}
                                </div>
                                <div className="forms-inputs mb-2">
                                    <span>Regional</span>
                                    <select className="form-select btn-sm btn-light text-center " onChange={(e) => { setRegional(e.target.value); setError({}) }}>
                                        <option value=''> NINGUNO</option>
                                        <option value="990">Cochabamba</option>
                                        <option value="991">Santa Cruz</option>
                                    </select>
                                    {error.error !== undefined && regional == '' && <div className="alert alert-danger text-uppercase m-0 p-0">
                                        seleccione tu sucursal
                                    </div>}
                                </div>
                                <div className="forms-inputs mb-4 text-center">
                                    <button className='btn btn-secondary bg-gradient' onClick={() => buscarUsuario()}>
                                        <i className="fa-solid fa-unlock fa-fade"></i>
                                        <span className="px-1">Recuperar Contraseña</span></button>
                                    {error.error != undefined && <div className="alert alert-danger text-uppercase m-0 p-0">
                                        {error.error}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <Modal show={modalShow} onHide={() => { setModalShow(false); setVista(0) }}
                size="sm"
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <div className='text-light fw-bold text-center'>Su Informacion es ...</div>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid text-light">
                        <div className="">
                            Usuario: {info.NOMBRE_USUARIO}
                        </div>
                        <div className="">
                            Contraseña: {info.CLAVE_USUARIO}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Tareas;